<template>
    <div class="container-medium well m-auto mt-8 external-plugins">
        <ul v-if="plugins.length > 0">
            <li
                v-for="(plugin, indexPlugin) in sortedPlugins"
                :key="indexPlugin"
                class="dinlineb span_2 gutters valign-top acenter"
            >
                <a
                    :href="plugin.url"
                    :onClick="plugin.call"
                    class="block p-4 b-1-black-hover cpointer br w-160 m-auto black"
                >
                    <CompassIcon
                        v-if="plugin.isSlsyIcon"
                        :customFile="pathSlsyIcon(plugin.iconSvg)"
                        :customIcon="plugin.iconSvg"
                        class="compassIcon"
                    />
                    <icon-svg v-else :height="40" :width="41" icon-name="card" viewBox="0 0 41 40">
                        <component
                            :is="plugin.iconSvg !== undefined ? 'icon-' + plugin.iconSvg : ''"
                        />
                    </icon-svg>
                    <p class="gray-100 fs-3 semibold m-0 mt-2">{{ plugin.label }}</p>
                </a>
            </li>
        </ul>
        <div v-else class="placeholder">
            <p>{{ $l10n.__("Vous n'avez pas de module externe") }}</p>
        </div>
    </div>
</template>

<script>
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconCard from 'vcomponents/icons/IconCard.vue';
import IconDrive from 'vcomponents/icons/IconDrive.vue';
import IconDropbox from 'vcomponents/icons/IconDropbox.vue';
import IconMailChimp from 'vcomponents/icons/IconMailChimp.vue';
import IconMailjet from 'vcomponents/icons/IconMailjet.vue';
import IconOffice365 from 'vcomponents/icons/IconOffice365.vue';
import IconPaypal from 'vcomponents/icons/IconPaypal.vue';
import IconSignature from 'vcomponents/icons/IconSignature.vue';
import IconStripe from 'vcomponents/icons/IconStripe.vue';
import IconAnnuaire from 'vcomponents/icons/IconAnnuaire.vue';
import IconSimpleMail from 'vcomponents/icons/IconSimpleMail.vue';
import IconSync from 'vcomponents/icons/IconSync.vue';
import IconScheduler from 'vcomponents/icons/IconScheduler.vue';
import IconTreasury from 'vcomponents/icons/IconTreasury.vue';
import AdyenIcon from 'svg/adyen.svg';
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');

export default {
    props: {
        pluginPrefsToLoad: {
            type: String,
            required: false,
            validator(value) {
                return ['GoogleSync', 'GoogleDrive', 'OutlookSync'].includes(value);
            },
        },
    },
    computed: {
        ...settingsStore.mapGetters({
            plugins: 'getExternalPlugins',
            permissions: 'getPermissions',
        }),
        sortedPlugins() {
            return this.plugins.sort((a, b) => {
                return a.label.localeCompare(b.label);
            });
        },
        pathSlsyIcon() {
            return (icon) => require(`svg/${icon}.svg?pathOnly`).default;
        },
    },
    created() {
        if (this.pluginPrefsToLoad) {
            this.openPrefs();
        }
    },
    methods: {
        /**
         * Open legacy preferences popup for some modules.
         * @see this.pluginPrefsToLoad
         */
        openPrefs() {
            eval(this.pluginPrefsToLoad).loadPrefs();
        },
    },
    components: {
        IconSvg,
        'icon-card': IconCard,
        'icon-drive': IconDrive,
        'icon-dropbox': IconDropbox,
        'icon-mailChimp': IconMailChimp,
        'icon-mailjet': IconMailjet,
        'icon-office365': IconOffice365,
        'icon-paypal': IconPaypal,
        'icon-signature': IconSignature,
        'icon-stripe': IconStripe,
        'icon-annuaire': IconAnnuaire,
        'icon-simpleMail': IconSimpleMail,
        'icon-sync': IconSync,
        'icon-scheduler': IconScheduler,
        'icon-treasury-nav': IconTreasury,
        'icon-adyen': AdyenIcon,
    },
};
</script>
<style lang="scss" scoped>
.compassIcon {
    height: 40px;
    margin: auto;
    width: 41px;
}
</style>
